import { render } from "./Historial.vue?vue&type=template&id=11b75993"
import script from "./Historial.vue?vue&type=script&lang=js"
export * from "./Historial.vue?vue&type=script&lang=js"

import "./Historial.vue?vue&type=style&index=0&id=11b75993&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__